// Client-side mirror of the API's COA rules (#476, DecisionLog I3: the
// ProductCoaFile rule, ProductValidation:AllowedCoaTypes and MaxCoaSizeMB), so
// a file the API would refuse is named before the round-trip. The API stays
// authoritative.

// The API's default AllowedCoaTypes: PDF, JPG or PNG, never SVG. It compares
// the browser-reported content type exactly, so a file with no type is
// refused too.
export const ACCEPTED_COA_TYPES = [
    "application/pdf",
    "image/jpeg",
    "image/jpg",
    "image/png",
];

// MaxCoaSizeMB. The API refuses a file LARGER than this, and an empty one; a
// file of exactly this size is accepted.
export const MAX_COA_MB = 10;
const MAX_COA_BYTES = MAX_COA_MB * 1024 * 1024;

// The message for a file the API would refuse as a COA, naming the file and
// the reason, or null when it is acceptable.
export const productCoaError = (file: File): string | null => {
    if (!ACCEPTED_COA_TYPES.includes(file.type)) {
        return `${file.name} can't be the COA: it must be a PDF, JPG or PNG file.`;
    }

    if (file.size === 0) {
        return `${file.name} can't be the COA: it is empty.`;
    }

    if (file.size > MAX_COA_BYTES) {
        return `${file.name} can't be the COA: it is larger than ${MAX_COA_MB} MB.`;
    }

    return null;
};
